import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from '@shared-services/permissions.service';
import { AuthService } from '@service-features/auth.service';

export const loginGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedUser) {
    router.navigate([inject(PermissionsService).landingUrl]);
    return false;
  }
  return true;
};
